import script from "./Mb.vue?vue&type=script&lang=js"
export * from "./Mb.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__